import { useQuery } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { IPaginatedResponse, IUrbanPartnerSimple } from "../types/seederOrders";

const API = process.env.REACT_APP_API;

interface UseUrbanPartnersParams {
  search?: string;
}

const useUrbanPartners = (params?: UseUrbanPartnersParams) => {
  const fetch = useFetch();

  const queryParams = new URLSearchParams();
  if (params?.search?.trim()) {
    queryParams.append("search", params.search.trim());
  }

  const queryString = queryParams.toString();
  const url = `${API}/api/semeadora/urban-partners/${queryString ? `?${queryString}` : ""}`;

  return useQuery({
    queryKey: ["urban-partners", params],
    queryFn: () => {
      return fetch(url, {
        method: "GET",
      }) as Promise<IPaginatedResponse<IUrbanPartnerSimple>>;
    },
  });
};

export default useUrbanPartners;
